import { DeviceStepProps } from '@/libs/onboarding';
import styles from './DeviceList.module.css';
import { Empty, LoadingProgress } from '@oolio-group/design-ui-react';
import { DeviceConfigHeader } from '../common/DeviceConfigHeader';
import { ErrorMessage } from '@/components/error-message/ErrorMessage';
import { isDeviceConfigured } from '../util';
import { DeviceWithConfig } from '@/types/common';

export const DeviceList = ({
  filteredDevices,
  loading,
  error,
  searchTerm,
  onSelectDevice,
  onBack,
  onRetry,
  onSearchChange,
  devices,
}: DeviceStepProps<DeviceWithConfig>) => {
  const renderContent = () => {
    if (loading) {
      return <LoadingProgress color="var(--accent)" loading />;
    }

    if (error) {
      return <ErrorMessage message={error} onRetry={onRetry} />;
    }

    if (!devices || devices.length === 0) {
      return <Empty label="No devices found." />;
    }

    if (filteredDevices.length === 0) {
      return <Empty label="No matching devices found" />;
    }

    return (
      <div className={styles.deviceList}>
        {filteredDevices.map(device => (
          <button
            key={device.id}
            className={styles.deviceCard}
            onClick={() => onSelectDevice(device)}
          >
            <div className={styles.deviceInfo}>
              <h3 className={styles.deviceName}>{device.name}</h3>
              <div className={styles.deviceStatus}>
                <span
                  className={styles.statusItem}
                  data-status={device.isPaired ? 'paired' : 'not-paired'}
                >
                  {device.isPaired ? 'Paired' : 'Not Paired'}
                </span>
              </div>
            </div>
            <div className={styles.deviceActions}>
              {!isDeviceConfigured(device) && (
                <span className={styles.actionText}>No Configuration</span>
              )}
            </div>
          </button>
        ))}
      </div>
    );
  };

  return (
    <>
      <DeviceConfigHeader
        title="Select a device to continue..."
        onBack={onBack}
        showSearch
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        searchLabel="Search devices..."
      />

      <div className={styles.contentArea}>{renderContent()}</div>
    </>
  );
};
